import Swiper, {Pagination} from "../../assets/.npm/node_modules/swiper";

export default () => {
  let swiperBanner = new Swiper(".slider-banner", {
    modules: [Pagination],
    slidesPerView: 1, 
    loop: true,
    pagination: {
      el: '.banner-pag',
      clickable: true,
    },
  });
}
  
